<ng-template #modalContent let-modal>
  <div class="modal-header border-bottom p-3">
    <h6 id="offcanvasAddUserLabel" class="offcanvas-title">
      {{ "UserPermission" | translate }}
    </h6>
    <button
      type="button"
      class="btn-close close-modal-button text-reset"
      (click)="modal.dismiss('Cross click')"
      aria-label="Close"
    ></button>
  </div>

  <div class="modal-body mx-0 flex-grow-0">
    <div class="row m-0">
      <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
        <!-- Leaf nodes -->
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
          <div class="d-flex align-items-center">
            <button mat-icon-button disabled></button>
            <input
              class="form-check-input"
              type="checkbox"
              [checked]="node.hasAccess"
              [(ngModel)]="node.hasAccess"
              (change)="changeChildAccess(node)"
            />

            <i
              class="ms-1 me-2 mb-0 icon-tree"
              [class]="node.icon"
              [style.color]="node.color"
            ></i>
            <span [style.color]="node.color">{{
              node.viewName | translate
            }}</span>
          </div>
        </mat-tree-node>

        <!-- Expandable nodes -->
        <mat-tree-node
          *matTreeNodeDef="let node; when: hasChild"
          matTreeNodePadding
        >
          <div class="d-flex align-items-center">
            <button mat-icon-button matTreeNodeToggle>
              <mat-icon>
                {{
                  treeControl.isExpanded(node) ? "expand_more" : "chevron_left"
                }}
              </mat-icon>
            </button>
            <input
              class="form-check-input"
              type="checkbox"
              [checked]="node.hasAccess"
              [(ngModel)]="node.hasAccess"
              (change)="changeParentAccess(node)"
            />
            <i
              class="ms-1 me-2 mb-0 icon-tree"
              [class]="node.icon"
              [style.color]="node.color"
            ></i>
            <span [style.color]="node.color">{{
              node.viewName | translate
            }}</span>
          </div>
        </mat-tree-node>
      </mat-tree>
    </div>
  </div>

  <div class="modal-footer border-top p-3">
    <button
      type="submit"
      class="btn btn-primary me-sm-3 me-1 data-submit"
      (click)="onSubmit()"
    >
      {{ "Submit" | translate }}
    </button>
    <button
      type="reset"
      class="btn btn-label-secondary"
      (click)="modal.dismiss('Cross click')"
    >
      {{ "Cancel" | translate }}
    </button>
  </div>

  <app-loading-panel *ngIf="loading"></app-loading-panel>
</ng-template>
